<template>
  <div class="horizontal-list-tabbed">
    <v-tabs v-model="tab" align-tabs="left">
      <v-tab
        :ripple="false"
        class="tab-flix"
        v-for="(t, i) in assets"
        :value="i"
        v-bind:key="i"
        ><h2>{{ t.title }}</h2></v-tab>
    </v-tabs>
    <v-window v-model="tab">
      <v-window-item v-for="(t, n) in assets" :key="n" :value="n">
        <v-container fluid>
          <swiper
            :modules="modules"
            :slides-per-view="slidesPerView"
            :space-between="20"
            navigation
            :pagination="false"
            :scrollbar="false"
            @swiper="onSwiper"
            @slideChange="onSlideChange"
          >
            <swiper-slide v-for="(asset, i) in t.assets" v-bind:key="i">
              <flat-horizontal-card
                :type="type"
                :asset="asset"
                :position="i"
                :img-alt="
                  type === 'movie'
                    ? $t('detail_page.watch_and_stream_movies', {
                        movie: asset.title,
                      })
                    : null
                "
              />
            </swiper-slide>
          </swiper>
        </v-container>
      </v-window-item>
    </v-window>
  </div>
</template>

<script>
// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from "swiper/vue";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import FlatHorizontalCard from "@/components/landing/carousel/FlatHorizontalCard.vue";
import { A11y, Navigation, Pagination, Scrollbar } from "swiper";
import { mapState } from "pinia";
import { UIStore } from "@/stores/uiStore";

export default {
  name: "TabbedHorizontalCarousel",
  components: {
    FlatHorizontalCard,
    Swiper,
    SwiperSlide,
  },
  props: {
    assets: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: false,
      default: "",
    },
  },
  computed: {
    ...mapState(UIStore, ["getCurrentWidth"]),
    slidesPerView() {
      return this.$breakpoints("horizontal", this.getCurrentWidth);
    },
  },
  data: () => ({
    tab: null,
  }),

  setup() {
    const onSwiper = (swiper) => {
      // console.log(swiper);
    };
    const onSlideChange = () => {
      console.log("slide change");
    };
    return {
      onSwiper,
      onSlideChange,
      modules: [Navigation, Pagination, Scrollbar, A11y],
    };
  },
};
</script>

<style lang="scss">
@import "src/assets/scss/colors";
.horizontal-list-tabbed {
  .v-tab--selected {
    .v-tab__slider {
      background: $red !important;
    }
  }

  .tab-flix {
    &:after {
      content: none !important;
    }
    .v-btn__overlay {
      display: none !important;
      opacity: 0;
    }

    .v-btn__underlay {
      display: none !important;
    }
    .v-btn__content > h2 {
      font-size: 0.875rem;
    }
    &.v-btn {
      padding: 0 !important;

      background: none;
      border: none;
      &.v-btn--density-default {
        height: 2.8em !important;
        padding: 0em 3em !important;
        margin: 0 1em;
      }

      &.v-slide-group-item--active {
        background: none !important;
      }
    }
  }
}
</style>
